module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back-home"
  }, _vm._l((_vm.choice), function(data) {
    return _c('div', {
      key: data.name,
      staticClass: "home-item"
    }, [_c('div', {
      staticClass: "home-head"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(data.text))]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("menuIcon")(data.icon)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "home-wrap"
    }, _vm._l((_vm.getSecondMenu(data)), function(item) {
      return _c('div', {
        key: item.name,
        staticClass: "text",
        on: {
          "click": function($event) {
            _vm.link(item.name)
          }
        }
      }, [_vm._v(_vm._s(item.text))])
    }))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5ac6bf22!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/home.vue
// module id = 748
// module chunks = 1